import { render, staticRenderFns } from "./safety-control.vue?vue&type=template&id=3eb3d001&scoped=true&"
import script from "./safety-control.vue?vue&type=script&lang=js&"
export * from "./safety-control.vue?vue&type=script&lang=js&"
import style0 from "./safety-control.vue?vue&type=style&index=0&id=3eb3d001&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb3d001",
  null
  
)

export default component.exports